define(function (require) {
	const tpl = require('./templates/t_itv_map_field.hbs');
	const baseElement = require('./v_itv_base_element');
	const MapView = require('civicsViews/map_view/v_cpqmap');
	const ViewManager = require('civicsUtils/view_manager');
	const MapUtil = require('civicsUtils/map_utilities');
	const GisSyncUtil = require('civicsUtils/gis_sync_utilities');
	const GisKeyCollection = require('civicsCollections/gis_key_collection');
	const ResultsView = require('civicsViews/map_view/v_lov_results_view');

	const general_utils = require('civicsUtils/general_utilities');

	return Marionette.LayoutView.extend(_.extend({}, baseElement.prototype, {
		template:tpl,
		initialize: function(options){
			this.config = options.config;
			this.listenTo(this, 'civics:zone-validation', this.handleZoneValidation);


		},
		onRender: function(){
			// Skip map initialization in read-only mode (e.g., print view)
			// The template will show the static value instead
			if(this.config.readOnlyForm){
				return;
			}
			let mapletId =  this.model.get("mapletId")?.split('?')[0] || '';
			const mapConfig = this.getMapConfig(mapletId);
			let isFirstRender = true;
			this.showMap(mapConfig);
			this.on("map:ready", ()=> {
				setTimeout(() => {
				if(isFirstRender){
					//need to refresh the map once and make sure map is attached fully to the DOM. 
					//Otherwise this is causing [NaN, NaN] map size when clicking next and recreating the map. 
					//Since we reset the screen, destroy and re insert a new one, OpenLayers map might not have the container since the map is hidden in a hidden tab.
					this.agencyMap?.currentView?.render();
					isFirstRender = false;
				}
				this.handleMapReady();
				}, 200)

			});

			this.on("map:adminfailure", function () {
					setTimeout(() => {
						//Maybe nothign to do here?
					}, 500);

				}.bind(this));
		
		},
		onBeforeDestroy: function () {
			this.trigger("map:destroy");
		},
		showMap: function (config) {
			if (this.$el.find('.mapView').length > 0) {
				if (!this.agencyMap) {
					this.addRegion("agencyMap", ".mapView");
				}
				else if (!this.agencyMap.$el) {
					this.agencyMap.reset();
					this.agencyMap._ensureElement();
				}
			
			}
			if (this.agencyMap && this.agencyMap.$el) {
				const mapletId = this.model.get("mapletId")?.split('?')[0] || '';
				if (mapletId && mapletId.length > 0) {
					this.agencyMap.show(new MapView({
						config: {
							mapConfig: config.json,
							channel: this
						}
					}));

				}
			}

			this.handleMapClickResults();
		},
		getMapConfig: function (mapletId) {
			let config = {};
			if (!this.isJson(mapletId, config)) {
				config.json = mapletId;
			}
			return config;
		},
		isJson: function (str, o) {
			try {
				o.json = JSON.parse(str);
				if (typeof o.json === "object" && o.json !== null) {
					return true
				}
			} catch (e) {
			}
			return false;
		},

		// Set the selected location and modify the DOM
		setSelectedLocation: function(selectedObject) {
			this.selectedLocationId = "addSites" + selectedObject.attributes.id;
			$('#' + this.selectedLocationId).prop('checked', true);
		},
		
		// Initialize the map layers based on the selected object
		initMapLayers: function(selectedObject) {				
				if (selectedObject.attributes.PRCLID) {
					this.handleParcelLayer(selectedObject);
				} else if (selectedObject.attributes.ADDRKEY) {
					this.handleAddressLayer(selectedObject);
				} else {
					this.handlePointsLayer(selectedObject);
				}
		},
		
		// Handle Parcel Layer addition based on PRCLID
		handleParcelLayer: function(selectedObject) {
			const prclId = selectedObject.attributes.PRCLID;
			const parcelObj = {
				'layer-name': 'parcel-features',
				symbology: 'parcels',
				layers: [{ features: [selectedObject] }]
			};
			setTimeout(() => {
				this.trigger("add-to-parcel-layer", { out: parcelObj });
			}, 10);

		},
		
		// Handle Address Layer addition based on ADDRKEY
		handleAddressLayer: function(selectedObject) {
			const addrKey = selectedObject.attributes.ADDRKEY;
			const addressObj = {
				'layer-name': 'address-features',
				symbology: 'addresses',
				layers: [{ features: [selectedObject] }]
			};
			setTimeout(() => {
				this.trigger("add-to-address-layer", { out: addressObj });
			}, 10);
		},
		
		// Handle Points Layer addition if no PRCLID or ADDRKEY is available
		handlePointsLayer: function(selectedObject) {
			const ofeatureInners = [selectedObject];
			const ofeatures = [{ features: ofeatureInners }];
			const pointsLayer = { 'layer-name': 'points', symbology: 'points', layers: ofeatures };
			this.trigger("add-to-points-layer,auto-zoom", pointsLayer);
		},
		
		handleMapReady: function(){
			const value = this.agencyMap?.$el?.attr('value');
			if (value && value.length > 0) {
				const selectedObject = JSON.parse(value);
				this.setSelectedLocation(selectedObject);
				this.initMapLayers(selectedObject);
			}	

		},
		// Handle results when a map click event occurs
		handleMapClickResults: function () {
			this.on("civics:map-click-results", info => {
			ViewManager.loading(true);
			this.rawFeatures = [];
			this.populateFeatures(info);
			this.syncModels()
				.then(() => this.getGisKeyMappings())
				.then((gisToIpsMapping) => this.processRawFeatures(gisToIpsMapping))
				.catch((error) => {
					ViewManager.loading(false);
					ViewManager.openAlert(i18n.t('CIVICS.COMMON.GIS_SYNC_ERROR'));
				});
			});
		},
		handleZoneValidation: function (o) {
			if (!o.selected || o.selected.length === 0) return;
		
			let reportedFeatures = [];
			let valid = true;
			let message = '';
		
			// Check for validity and gather reported features
			if (o.raw?.args?.out?.events) {
				_.forEach(o.raw.args.out.events, (event) => {
					if (event.eventArgs.out.hasOwnProperty('valid')) {
						if (!event.eventArgs.out.valid) {
							valid = false;
							message += '\n' + (event.eventArgs.out.reason === 'count_out_of_bounds' 
								? i18n.t('CIVICS.COMMON.INVALID_LOCATION_MESSAGE') 
								: event.eventArgs.out.reason);
						}
					} else {
						reportedFeatures = reportedFeatures.concat(event.eventArgs.out.layers[0].features);
					}
				});
			}
		
			if (valid) {
				const id = this.agencyMap.$el.attr('id');
				const validationData = JSON.stringify({ selected: o.selected[0], features: reportedFeatures });
		
				if (o.snapshot) {
					o.selected[0].snapshot = o.snapshot;
				}
		
				const value = JSON.stringify(o.selected[0]);
				const delegate = this.agencyMap.$el.attr('data-maplet-delegate');
		
				if (delegate && delegate.length > 0) {
					const IpsModelValid = IpsModel.extend({
						urlRoot: '/delegate/civics-api/api/portal/scenario/map/location/validation',
					});
					const model = new IpsModelValid({ formulaName: delegate });
					model.set('Data', validationData, { silent: true });
		
					model.save()
						.done((response) => {
							this.processMapSiblings(response.data.isValid);
							this.siteSelectedFeature = null;
						})
						.fail((response) => {
							ViewManager.errorToWindow(response);
						});
				} else {
					this.siteSelectedFeature = null;
				}
			} else {
				ViewManager.openAlert(i18n.t('CIVICS.COMMON.INVALID_LOCATION', { location: message }));
			}
		},
		// Populate raw features from map click results
		populateFeatures: function(info) {
			const events = info.raw.args.out?.events || [];
			events.forEach(event => {
				const features = event.eventArgs.out.layers['0'].features || [];
				this.rawFeatures.push(...features);
			});
		
			const featureBox = MapUtil.coordsToFeature(info.raw.args.in.findOption('box'));
			if (featureBox) {
				this.rawFeatures.push(featureBox);
			}
		},
		processMapSiblings: function (isValid) {
			const sibs = this.getMapSibling();
			if (sibs && sibs.length > 0) {
				_.forEach(sibs, (sib) => {
					const input = $(sib).find(":input").not(':button, :input[type=button], :input[type=submit], :input[type=reset]');
					if (input && input.length > 0) {
						$(input[0]).val(isValid);
						const inputId = $(input[0]).attr('id');
						if (inputId) {
							this.selectionClicked(inputId, $(input[0]).val());
						}
					}
				});
			}
		},
		getMapSibling: function () {
			return this.agencyMap.$el.parent().parent().siblings();
		},

		// Sync models based on GIS data and store in session storage
		syncModels: function() {
			const syncData = this.rawFeatures.map(feature => GisSyncUtil.createSyncModel(feature.attributes)).filter(Boolean);
			return $.when(...syncData.map(data => data.fetch()))
				.then(() => GisSyncUtil.saveSyncDataToSessionStorage(syncData));
		},
		
		// Get GIS key mappings based on the synced models
		getGisKeyMappings: function() {
			const gisKeyMappings = this.rawFeatures
				.filter(feature => !feature.attributes.gisKey)
				.map(feature => GisSyncUtil.getGisKeyFromMapping(feature.attributes))
				.filter(Boolean);
		
			if (gisKeyMappings.length === 0) {
				return Promise.resolve({});
			}
		
			const gisKeyModel = new GisKeyCollection();
			return gisKeyModel.fetch({
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({ 'GisKeys': gisKeyMappings })
			}).then(() => GisSyncUtil.mapSyncKeys(gisKeyModel));
		},
		
		// Process raw features, map GIS keys, and display results
		processRawFeatures: function(gisToIpsMapping) {		
			this.featureColl = new Backbone.Collection();
		
			this.rawFeatures.forEach(feature => {
				const mappingKey = `${feature.attributes.gisKey}-${feature.attributes.syncMappingId || ''}`;
				const mappedKey = gisToIpsMapping[mappingKey];
		
				if (mappedKey && feature.attributes.hasSyncKey) {
					if (feature.attributes.syncEventType === 'parcel') {
						feature.attributes.PRCLKEY = parseInt(mappedKey);
					} else if (feature.attributes.syncEventType === 'address') {
						feature.attributes.ADDRKEY = parseInt(mappedKey);
					}
				}

				const processedModel = MapUtil.processMapModel(feature.attributes);
				this.featureColl.add(processedModel);
			});
		
			ViewManager.loading(false);
			this.displayResults();
		},
		
		// Display results in the results region
		displayResults: function () {
			if (this.$el.find('.results-region').length > 0) {
					_.extend(this.config, { coordsAllowed: true });
	
					this.resultsView = new ResultsView({
						config: this.config,
						collection: this.featureColl,
						rawFeatures: this.rawFeatures,
						inMapView: true
					});
					$('.results-region').html(this.resultsView.render().el);
			}
			if (this.selectedLocationId) {
				$('#' + this.selectedLocationId).prop('checked', true);
			}
			// }
			this.listenTo(this.resultsView, 'siteSelected', this.onSiteSelected);
			if (this.rawFeatures && this.rawFeatures.length > 0) {
				this.toggleMapResult(false);
			}
		},
		onSiteSelected: function (selectedSiteID, description, model) {

			this.siteSelected(selectedSiteID);
			// if (this.siteSelectedFeature){
			// 	this.trigger('use-this-parcel', { activeFeature: this.siteSelectedFeature[0] });

			//  }
			this.model.set('value', JSON.stringify(this.siteSelectedFeature[0]), {silent: true});

		},
		siteSelected: function (selectedSiteID) {
			const selectedValue = selectedSiteID;
		
			if (selectedValue.startsWith('address')) {
				this.siteSelectedKey = selectedValue.substring(7);
				this.siteSelectedFeature = _.filter(this.rawFeatures, o => 
					o.attributes && o.attributes.ADDRKEY && o.attributes.ADDRKEY == this.siteSelectedKey
				);
			} else if (selectedValue.startsWith('parcel')) {
				this.siteSelectedKey = selectedValue.substring(6);
				this.siteSelectedFeature = _.filter(this.rawFeatures, o => 
					o.attributes && o.attributes.PRCLKEY && o.attributes.PRCLKEY == this.siteSelectedKey
				);
			} else if (selectedValue.startsWith('coord')) {
				this.siteSelectedKey = selectedValue.substring(5);
				this.siteSelectedFeature = _.filter(this.rawFeatures, o => {
					const lat = o.attributes.lat ? o.attributes.lat.toString() : '';
					const lon = o.attributes.lon ? o.attributes.lon.toString() : '';
					return (lat + lon === this.siteSelectedKey);
				});
			} else {
				this.siteSelectedKey = null;
				this.siteSelectedFeature = [];
			}
		
		
		},		

		toggleMapResult: function (hide) {
			if (this.$el.find('.mapView').length > 0) {
				if (hide) {
					$('.map-wrapper').removeClass('show-results');
				}
				else {
					$('.map-wrapper').addClass('show-results');
				}
			}
		},
		validateMap: function () {
			var map = $('.mapView');
			var mapValue = map.attr('value');

			if (map.hasClass('required') && (typeof mapValue === 'undefined' || mapValue === null || mapValue === '')) {
				//if target div has no value. Validate the result-region.
				var radios = $('.map-result input:radio');
				var error = {};

				if (radios.length > 0) {
					var radioSet = radios.filter(function (index) { return $(this).attr('name') == 'additionalSites' });
					if (!$(radioSet).is(':checked')) {
						error.validationError = {};
						error.validationError.additionalSites = i18n.t('CIVICS.COMMON.SELECTION_REQ_ERROR');
						ViewManager.errorToWindow(error, this);
						return true;
					}
					return false;
				} else {
					error.validationError = {};
					var id = map.attr('id') + '-helper';
					error.validationError[id] = i18n.t('CIVICS.COMMON.LOCATION_REQUIRED');
					ViewManager.errorToWindow(error, this, { byID: 'true' });
					return true;
				}
			}
			return false;
		},
		getData: function () {
			var data = {};
			var val = this.getValue();
			if (val === null || val === "") {
				return null; // Return null if value is invalid or empty
			} else{
				data[this.model.get('id')] = val;
			}

			return data;
		},

		getValue: function () {
			let hasError = this.validateMap();
			let value =	hasError ? null : this.model.get('value');

			return value;
		},

		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);
			var self = this;
			return $.extend({},baseTH,{
				id:self.model.get('id'),
				classes:'',
				labelText:self.model.get('text'),
				helperMsg:'',
				helperMsgId: self.model.get('id') + "-helper",
				html: false,
				disabled: false,
				showValue: self.config.readOnlyForm,
				isRequired: self.model.get('isRequired'),
				requiredClass: self.model.get('isRequired') ? 'required' : '',
				tooltip: self.model.get('description') ? general_utils.attributeEscapeString(ele.description) : '',
				mapletId: self.model.get('mapletId'),
				mapTitle: i18n.t('CIVICS.INSTRUMENT_SUBMIT.MAP_TITLE'),
				searchHelperText: i18n.t('CIVICS.INSTRUMENT_LIST.SEARCH_HELPER_TEXT'),
				delegateFormula: self.model.get('delegateFormula'),
				value: self.config.readOnlyForm ? MapUtil.formatSiteDescription(self.model.get('value')): self.model.get('value')
			});

		}

	}));
});
